<div class="ngb-tabs" *ngIf="!isFormView" [ngClass]="{ 'submit-hide-multiple-tab': hideMultipleTab }">
    <ul ngbNav #nav="ngbNav" (navChange)="onTabChange($event)" [destroyOnHide]="false" class="nav-tabs nav-justified">
        <li [ngbNavItem]="TABS.SINGLE">
            <a ngbNavLink *ngIf="!hideMultipleTab">Single <span class="hide-mobile">entry</span></a>
            <ng-template ngbNavContent>
                <cm-dynamic-form
                    class="submit-form tab"
                    [elements]="formFields"
                    [showErrors]="showErrors"
                    [displayMessages]="displayMessages"
                    [disabled]="disabled"
                    [sections]="sections"
                >
                </cm-dynamic-form>
            </ng-template>
        </li>
        <li [ngbNavItem]="TABS.MULTIPLE">
            <a ngbNavLink *ngIf="!hideMultipleTab">Multiple <span class="hide-mobile">entries</span></a>
            <ng-template ngbNavContent>
                <div class="template-form tab">
                    <p class="template-form__title">Template</p>
                    <p class="template-form__description">
                        To upload multiple entries please download the provided xls template. Once you fill in all
                        required fields in the xls file, upload it to submit entries. Please make sure the information
                        provided is in the format required in the file.
                    </p>
                    <p class="template-form__link">
                        <a class="cm-link" [href]="step.excel_link" target="_blank">Download template</a>
                    </p>
                    <p class="template-form__uploader-label">Upload template</p>
                    <cm-file-upload (change)="onFilesChange($event)" [files]="files"></cm-file-upload>
                    <cm-inline-error *ngIf="noFilesError" [errorMessages]="noFileError"></cm-inline-error>
                </div>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<div *ngIf="isFormView">
    <cm-dynamic-form
        class="submit-form tab"
        [elements]="formFields"
        [showErrors]="showErrors"
        [displayMessages]="displayMessages"
        [disabled]="disabled"
        [sections]="sections"
    >
    </cm-dynamic-form>
</div>
